export const checkIsNewActiveElement = ({
  activeEl,
  activeIndex,
  index,
  previousIndex,
  slidesPerView,
  slidesLength,
}: {
  activeEl: null | HTMLElement;
  activeIndex: number;
  index: number;
  previousIndex: number | undefined;
  slidesPerView: number;
  slidesLength: number;
}): boolean => {
  if (slidesLength <= slidesPerView) return false;

  return !!activeEl && activeIndex === index && previousIndex !== undefined;
};
